import styled from 'styled-components';

const FooterWrapper = styled('div')`
  margin-top: 48px;
`;

export default FooterWrapper;
